import React, {useEffect, useState} from 'react';
import {format, parseISO} from 'date-fns';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';

import Modal from '../../common/components/Modal';
import {hetch} from "../../utils/fetch.hooked";

const checkLicenseInterval = 60000;

class ResponseError extends Error {
  constructor(response) {
    super();
    this.response = response;
  }
}

const action = (url) => {
  return hetch(url)
      .then((res) => {
        if (res.status >= 400) {
          throw new ResponseError(res);
        }
        return res.json();
      })
      .catch(console.error)
};

const isLicenseValid = () => {
  return hetch('/api/user-license/is-license-valid')
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          return true;
        }
      })
      .catch(console.error)
};

const getLicense = () => {
  return Promise.all([
    action('/api/user-license/license-status'),
    action('/api/user-license/license-status-enum')
  ]).then(([license, statuses]) => {
    const currentStatus = statuses.find(({enumName}) => enumName === license.licenseStatus);
    return {
      ...license,
      licenseStatus: currentStatus.reasonRus ?? license.licenseStatus,
    };
  })
};

export default function AppLicenseModal() {
  const [isValid, setIsValid] = useState(true);
  const [license, setLicense] = useState({});
  useEffect(() => {
    isLicenseValid().then(setIsValid).catch(console.error);
    const intervalId = setInterval(() => {
      isLicenseValid().then(setIsValid).catch(console.error);
    }, checkLicenseInterval);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  useEffect(() => {
    if (!isValid) {
      getLicense().then(setLicense).catch(console.error)
    }
  }, [isValid])
  return (
    <Modal
      header="Лицензия"
      open={!isValid}
      disableAutoFocus={true}
    >
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>Статус лицензии</TableCell>
              <TableCell>{license.licenseStatus}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Владелец лицензии</TableCell>
              <TableCell>{license.licenseOwner}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Начало действия</TableCell>
              <TableCell>
                {license.licenseCreatedAt  ? format(parseISO(license.licenseCreatedAt), 'dd.MM.yyyy HH:mm') : ''}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Конец действия</TableCell>
              <TableCell>
                {license.licenseExpireTime ? format(parseISO(license.licenseExpireTime), 'dd.MM.yyyy HH:mm') : ''}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
}
